const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const GotProblems = require("./GotProblems");
const Copy = require("../util/CopyTable").get404Copy();

module.exports = createReactClass({
	displayName: "Page404",

	propTypes: {
		pathname: PT.string,
	},

	render: function() {
		return <GotProblems message={Copy.message} />;
	},
});
